import grapesjs from 'drapcode-builder';
import loadComponents from './components';
import loadBlocks from './blocks';
import loadTraits from './traits';
import { colFormRef } from './consts';

export default grapesjs.plugins.add('gjs-login-form', (editor, opts) => {
  let c = opts || {};

  let defaults = {
    pfx: 'login-form',
    blocks: [colFormRef],
    defaultStyle: true,
    labelColForm: 'Login Form',
    labelColFormCategory: 'Forms',
    labelTraitMethod: 'Method',
    labelTraitAction: 'Action',
    labelColName: 'Collection',
  };

  for (let name in defaults) {
    if (!(name in c)) c[name] = defaults[name];
  }

  loadComponents(editor, c);
  loadTraits(editor, c);
  loadBlocks(editor, c);
});
